import { render, staticRenderFns } from "./Special-Program.vue?vue&type=template&id=c0987716&"
import script from "./Special-Program.vue?vue&type=script&lang=js&"
export * from "./Special-Program.vue?vue&type=script&lang=js&"
import style0 from "./Special-Program.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports